var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pill-container px-3",style:(`max-width: ${_vm.maxWidth};`)},[_c('v-icon',{attrs:{"dark":"","small":""}},[_vm._v(" "+_vm._s(_vm.icon))]),_c('span',{staticClass:"toast-text"},[_vm._v(" "+_vm._s(_vm.toastText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }